import { Button2 } from "@/ui2/atoms/Button";
import { DashboardCard2 } from "@/components/layout/DashboardCard2";
import { getAutomationDataAttr } from "@/utils/automationUtils";
import { Hint } from "@/ui2/atoms/Hint";
import { Link2 } from "@/ui2/atoms/Link";

type Props = {
  acceptedInsurance: string[];
  isAdmin: boolean;
  isDisabled: boolean;
  onEdit: () => void;
};

export function AcceptedInsuranceCard({ acceptedInsurance, isAdmin, isDisabled, onEdit }: Props) {
  const isEditAvailable = isAdmin && !isDisabled;

  return (
    <DashboardCard2
      Actions={
        isEditAvailable && (
          <Button2
            onPress={onEdit}
            size="sm"
            variant="link"
            {...getAutomationDataAttr("AcceptedInsuranceEditButton")}
          >
            Edit
          </Button2>
        )
      }
      data-public="true"
      title="Accepted Insurance"
    >
      <ul
        className="ProviderProfile__insurance-info-list fs-14"
        {...(isAdmin ? getAutomationDataAttr("AcceptedInsuranceList") : {})}
      >
        {acceptedInsurance.sort().map((ins) => (
          <li key={ins}>{ins}</li>
        ))}
      </ul>

      {!isAdmin && (
        <Hint>
          To update accepted insurance, contact{" "}
          <Link2 href="mailto:support@aptihealth.com" isExternal size="xs" variant="link">
            support@aptihealth.com
          </Link2>
          .
        </Hint>
      )}
    </DashboardCard2>
  );
}
